"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SteppedInfoPanel = exports.InfoPanelStepStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_use_1 = require("react-use");
const styled_components_1 = __importStar(require("styled-components"));
const Title = styled_components_1.default.div `
	font-size: 18px;
	font-weight: bold;
	color: ${({ theme }) => theme.color.brand3};
	margin-bottom: 1rem;
`;
const ContentWrapper = styled_components_1.default.div `
	padding: 2rem 1rem 2rem 2rem;
	display: flex;
	flex-direction: column;
	width: 66%;
	min-width: 66%;
	${({ isBelowBreakingPoint }) => isBelowBreakingPoint &&
    (0, styled_components_1.css) `
			background: ${({ theme }) => theme.color.gray2};
			border-radius: ${({ theme }) => theme.borderRadius.large};
			width: 100%;
			justify-content: center;
			align-items: center;
		`}
`;
const DescriptionText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.brand3};
	margin-bottom: 1rem;
	${({ isBelowBreakingPoint }) => isBelowBreakingPoint &&
    (0, styled_components_1.css) `
			text-align: center;
		`}
`;
const StepsWrapper = styled_components_1.default.div `
	height: ${({ height }) => `${height}rem`};
	${({ isBelowBreakingPoint }) => isBelowBreakingPoint &&
    (0, styled_components_1.css) `
			background: ${({ theme }) => theme.color.white};
			padding: 1.5rem;
			border-radius: ${({ theme }) => theme.borderRadius.large};
			height: ${({ height }) => `${height + 2}rem`};
		`} {
	}

	&& {
		.ant-steps-vertical {
			div:last-child {
				max-height: 2rem;
			}
		}
		.ant-steps-item-content,
		.ant-steps-item {
			min-height: 0;
			.ant-steps-item-title {
				color: ${({ theme }) => theme.color.brand3};
			}
		}
		.ant-steps-item-active {
			cursor: pointer;
			.ant-steps-item-container {
				width: max-content;
				border-top-left-radius: 15px;
				border-bottom-left-radius: 15px;
				border-top-right-radius: ${({ theme }) => theme.borderRadius.base};
				border-bottom-right-radius: ${({ theme }) => theme.borderRadius.base};
				box-shadow: 0px 0px 0px 1.5px ${({ theme }) => theme.color.brand3} inset;
			}
			.ant-steps-item-icon {
				background: ${({ theme }) => theme.color.brand3};
			}
		}
		.ant-steps-item-wait,
		.ant-steps-item-finish {
			& .ant-steps-item-title {
				opacity: 50%;
			}
		}
	}
`;
const GrayBox = styled_components_1.default.div `
	padding: 2rem;
	background: ${({ theme }) => theme.color.gray2};
	border-radius: ${({ theme }) => theme.borderRadius.large};
	width: 34%;
	display: flex;
	justify-content: center;
`;
var InfoPanelStepStatus;
(function (InfoPanelStepStatus) {
    InfoPanelStepStatus["done"] = "done";
    InfoPanelStepStatus["active"] = "active";
    InfoPanelStepStatus["toBeDone"] = "toBeDone";
})(InfoPanelStepStatus || (exports.InfoPanelStepStatus = InfoPanelStepStatus = {}));
const { Step } = elements_1.Steps;
const SteppedInfoPanel = ({ title, description, Illustration, steps, onActiveClick }) => {
    const activeIndex = steps.findIndex(step => step.status === InfoPanelStepStatus.active);
    const calculateStepsHeight = steps.length * 3.5;
    const [ref, { width }] = (0, react_use_1.useMeasure)();
    const isBelowBreakingPoint = width < 600;
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: `flex-row ${isBelowBreakingPoint ? 'p-sm' : 'p-xs'}`, measureRef: ref, children: [(0, jsx_runtime_1.jsxs)(ContentWrapper, { isBelowBreakingPoint: isBelowBreakingPoint, children: [(0, jsx_runtime_1.jsx)(Title, { children: title }), description && description.length && ((0, jsx_runtime_1.jsx)("div", { className: "flex-col", children: description.map((desc, i) => ((0, jsx_runtime_1.jsx)(DescriptionText, { isBelowBreakingPoint: isBelowBreakingPoint, children: desc }, `description-${i}`))) })), (0, jsx_runtime_1.jsx)(StepsWrapper, { isBelowBreakingPoint: isBelowBreakingPoint, height: calculateStepsHeight, children: (0, jsx_runtime_1.jsx)(elements_1.Steps, { className: "height-100", direction: "vertical", current: activeIndex, children: steps.map(step => ((0, jsx_runtime_1.jsx)(Step, { title: step.title, onClick: step.status === InfoPanelStepStatus.active ? () => onActiveClick === null || onActiveClick === void 0 ? void 0 : onActiveClick() : undefined }, step.status))) }) })] }), !isBelowBreakingPoint && ((0, jsx_runtime_1.jsx)(GrayBox, { children: (0, jsx_runtime_1.jsx)(Illustration, {}) }))] }));
};
exports.SteppedInfoPanel = SteppedInfoPanel;
